import { Control } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import { InvoiceFormValues } from "./types";

interface InvoiceCustomFieldsProps {
  control: Control<InvoiceFormValues>;
  disabled?: boolean;
}

const InvoiceCustomFields = ({
  control,
  disabled,
}: InvoiceCustomFieldsProps) => {
  return (
    <>
      <FormField
        control={control}
        name="projectName"
        render={({ field }) => (
          <FormItem className="space-y-2">
            <FormLabel>Project Name</FormLabel>
            <FormControl>
              <Input
                placeholder="e.g. Website Redesign Phase 2"
                {...field}
                disabled={disabled}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="poNumber"
        render={({ field }) => (
          <FormItem className="space-y-2">
            <FormLabel>PO Number</FormLabel>
            <FormControl>
              <Input
                placeholder="e.g. PO-2026-001"
                {...field}
                disabled={disabled}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default InvoiceCustomFields;
